module.exports = __webpack_public_path__ + "img/SAS_Claymore.6c9929ab.png";